import React, { Component } from "react";

import { connect } from "react-redux";
import { addToCart } from "../../Redux/Actions/actions";
import Item from "../../Components/Item/item";
import "./shop.css";
import { Row, Col } from "reactstrap";
import Snackbar from "../../Components/Snackbar/snackbar";

class Shop extends Component {
  snackbarRef = React.createRef();

  render() {
    const addedItem = (value) => {
      this.snackbarRef.current.openSnackBar("Item Added to Cart!");
      this.props.addToCart(value);
    };
    return (
      <div>
        <Snackbar ref={this.snackbarRef} />
        <Row>
          <Col sm="12" lx="12">
            <div className="Shop-list">
              {this.props.inventory &&
                this.props.inventory.map((item) => {
                  return (
                    <Item key={item.id} item={item} addToCart={addedItem} />
                  );
                })}
            </div>
          </Col>
        </Row>
        <Row>
          <div className="Contact-customizations">
            {
              // TODO: Create contact form for customizations
              /* Contact me for customizations! */
            }
          </div>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    inventory: state.CartReducer.inventory,
    addedItems: state.CartReducer.addedItems,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToCart: (id) => {
      dispatch(addToCart(id));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Shop);
